import Group from 'components/utils/Group'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  season: string
  seasonHint?: string
  variant: 'small' | 'medium'
}

function WeddingVenueSeason(props: Props) {
  const { season, seasonHint, variant } = props

  const content = <Group direction="horizontal" gap={4} verticalAlign="center">
    <BodyText variant={variant} colour="light-foreground-alt">{season}</BodyText>
    {!!seasonHint && <LineInfoCircleIcon size="XS" colour="light-foreground-alt" />}
  </Group>

  if (!seasonHint) return content

  return <Tooltip description={seasonHint} placement="top">
    {content}
  </Tooltip>
}

export default WeddingVenueSeason
